import {
    Fragment,
    type FC
} from "react";
import {
    View
} from "react-native";
import type IProgressHeaderProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import type {
    ProgressPartContentProps
} from "../../type";
import {
    withProgressContext
} from "../../context";
import ProgressTitle from "../title";
import ProgressValue from "../value";

const ProgressHeaderContent: FC<ProgressPartContentProps<IProgressHeaderProps>> = ({
    customTheme: customThemeProp,
    children,
    context,
    style,
    ...props
}) => {
    const {
        spaces
    } = NCoreUIKitTheme.useContext(customThemeProp ?? context.customTheme);

    const {
        container: containerDynamicStyle
    } = useStyles({
        spaces
    });

    return <View
        {...props}
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
    >
        {
            children ?? <Fragment>
                <ProgressTitle />
                <ProgressValue />
            </Fragment>
        }
    </View>;
};
export default withProgressContext("Header", ProgressHeaderContent);
